'use strict';
import React, { PureComponent } from 'react';
import GrupoRadioButton from '../../Common/GrupoRadioButton';
import IndicadorInterfazBuscador from './IndicadorInterfazBuscador';

class SeccionDatosGenerales extends PureComponent {
    constructor(props) {
        super(props);

        this.cambiarCheck = this.cambiarCheck.bind(this);
        this.cambiarOpcionCombo = this.cambiarOpcionCombo.bind(this);
        this.validarInput = this.validarInput.bind(this);
    }

    cambiarCheck(nombreCheck, valor) {
        this.props.cambiarCheckABMModelos(nombreCheck, valor);
    }

    cambiarOpcionCombo(nombreCombo, valorCombo) {
        this.props.cambiarOpcionCombo(nombreCombo, valorCombo);
    }

    validarInput(event, nombreInput) {
        let valorInput = event.target.value;
        let regExp = "";
        let limiteCaracteres = 0;

        switch (nombreInput) {
            case "inputCodigoModelo":
                regExp = /^([1-9]|[1-9][0-9]+)$/ig;
                limiteCaracteres = 9;
                break;
            case "inputNombreModelo":
                regExp = /[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ \s]/ig;
                limiteCaracteres = 200;
                break;
            case "inputDiasDiferimiento":
                regExp = /^([0-9]|10)$/ig;
                limiteCaracteres = 2;
                break;
            default:
                break;
        }

        if ((!regExp.test(valorInput) && valorInput != "") || valorInput.length > limiteCaracteres) {
            event.preventDefault();
        } else {
            this.props.cambiarValorInput(undefined, nombreInput, valorInput);
        }
    }

    render() {
        const {
            checkAperturaPorSocio,
            checkAperturaPorSucursal,
            checkConfirmacionAutomatica,
            checkModeloHabilitado,
            checkRequiereReverso,
            comboSucursal,
            datosPantalla,
            datosRenglones,
            errorValidacion,
            esEdicion,
            indicadoresInterfazActivos,
            inputCodigoModelo,
            inputNombreModelo,
            inputDiasDiferimiento,
            marcasActivas,
            monedasActivas,
            permisoAlta,
            permisoBaja,
            permisoModificacion,
            radioButtonsABMModelos,
            sucursalesActivas,
            sugerenciaModelo,
            inputIndicadorInterfaz,
            mostrarResultadosIndicadorInterfaz,
            indicadorInterfazSeleccionado,
            descripcionIndicadorInterfazSeleccionado,
            indicadorInterfazFiltrados
        } = this.props;

        //ACTIONS
        const {
            buscarIndicadoresInterfaz,
            seleccionarRadioButtonABMModelos,
            mostrarOcultarResultadosIndicadorInterfaz
        } = this.props;


        //Se arma este objeto para organizar los datos obtenidos por obtenciones de datos
        const datosEdicion = {
            modelo: {
                codigo: datosPantalla && datosPantalla.length > 0 && datosPantalla[0].ModeloContableCabeceraId,
                descripcion: datosPantalla && datosPantalla.length > 0 && datosPantalla[0].DescripcionModelo,
                fechaBaja: datosPantalla && datosPantalla.length > 0 && datosPantalla[0].FechaBaja
            }
        }


        //Array que contendrá los valores de los radio buttons de las Marcas
        let arrayRbMarcas = [];
        //Array que contendrá los valores de los radio buttons de las Marcas
        let arrayRbMonedas = [];
        //Array que contendrá las opciones del combo de Sucursales
        let arrayOpcionesSucursal = [];
        //Array que contendrá las opciones del combo de Indicador de interfaz
        let arrayOpcionesIndicadorInterfaz = [];


        //Utilizo el formato de fecha de Gran Bretaña que me devuelve el formato en DD/MM/YYYY
        const fechaActual = datosEdicion.modelo.fechaBaja ? new Date(datosEdicion.modelo.fechaBaja).toLocaleDateString("en-GB") : new Date().toLocaleDateString("en-GB");

        const claseCheckInhabilitado = (esEdicion && (permisoModificacion || permisoBaja)) || (!esEdicion && permisoAlta) ? "" : " ABMModelos__checkboxBuscadorModelos--deshabilitado";
        const puedeModificar = esEdicion ? permisoModificacion : true;
        const checkDeshabilitado = puedeModificar ? "" : " ABMModelos__checkboxBuscadorModelos--deshabilitado";

        const poseeRenglonAutomatico = !!datosRenglones && datosRenglones.some(renglon => renglon.TipoRenglon == 1);

        //Genero los RB para las diferentes marcas activas e inactivas en el caso de corresponder
        marcasActivas.map(marca => {
            let claseMarca = "";
            let claseContenedora = "";

                switch (marca.Codigo) {
                    case "VISA":
                        claseMarca = "seccionDatosGenerales__marcaVisa";
                        break;
                    case "MASTER":
                        claseMarca = "seccionDatosGenerales__marcaMastercard";
                        break;
                    case "CABAL":
                        claseMarca = "seccionDatosGenerales__marcaCabal";
                        claseContenedora = " seccionDatosGenerales__contenedorCabal";
                        break;
                    case "AD17":
                        claseMarca = "seccionDatosGenerales__marcaAdintar";
                        break;
                    default:
                        claseMarca = "";
                        break;
                        
                }
            
                arrayRbMarcas.push(
                    <div key={marca.Codigo} className={"seccionDatosGenerales__contenedorMarca " + (esEdicion && poseeRenglonAutomatico ? "ABMModelos-contenedorRadioButtonMarcaDesactivado" : "")}>
                        <GrupoRadioButton 
                        activo={marca.Codigo == radioButtonsABMModelos.rbMarca}
                        classLabel={claseMarca}
                        estaHabilitado={!esEdicion && !poseeRenglonAutomatico} 
                        label={null}
                        nombre={"rbMarca"}
                        onClick={esEdicion || poseeRenglonAutomatico ? null : seleccionarRadioButtonABMModelos}
                        valor={marca.Codigo}
                      />
                    </div>
                  );
            });


        //Genero los RB para las diferentes monedas activas e inactivas en el caso de corresponder
        monedasActivas.map(moneda => {
            arrayRbMonedas.push(
                <div key={moneda.Codigo} className="seccionDatosGenerales__moneda">
                    <GrupoRadioButton 
                        activo={moneda.Codigo == radioButtonsABMModelos.rbMoneda}
                        classLabel={""}
                        estaHabilitado={puedeModificar}
                        label={moneda.Descripcion}
                        nombre={"rbMoneda"}
                        onClick={puedeModificar ? seleccionarRadioButtonABMModelos : null}
                        valor={moneda.Codigo}
                    />
                </div>
            );
        });


        //Lleno el combo de Sucursales. Se agrega la opción "Todas" como primer valor por default
        arrayOpcionesSucursal.push(
            <option key={0} value={0}>Todas</option>
        );

        sucursalesActivas.map(sucursal => {
            arrayOpcionesSucursal.push(
                <option key={sucursal.Id} value={sucursal.Id}>{sucursal.Descripcion}</option>
            );
        });


        //Lleno el combo de Indicador de interfaz. Se agrega la opción "Todas" como primer valor por default
        arrayOpcionesIndicadorInterfaz.push(
            <option key={0} value={0}>Seleccione...</option>
        );

        indicadoresInterfazActivos.map(indicador => {
            arrayOpcionesIndicadorInterfaz.push(
                <option key={indicador.Id} value={indicador.Id}>{indicador.ValorIndicador}</option>
            );
        });


        return (
            <div className="seccionDatosGenerales">
                <div className="TituloPrincipal">
                    Datos Generales del Modelo
                </div>

                <div className="lineaDivisoria"></div>

                <div className="seccionDatosGenerales__contenedor">
                    <div className="seccionDatosGenerales__codigoModelo">
                        <div className="seccionDatosGenerales__tituloSecundario">Código del modelo</div>

                        <input 
                            className="seccionDatosGenerales__inputSelect seccionDatosGenerales__inputCodigoModelo"
                            disabled={esEdicion}
                            id="inputCodigoModelo"
                            name="inputCodigoModelo"
                            onChange={(event) => !esEdicion ? this.validarInput(event, "inputCodigoModelo") : null}
                            placeholder={esEdicion ? "" : "Sugerencia: " + sugerenciaModelo}
                            type="text"
                            value={inputCodigoModelo}
                        />

                        {errorValidacion.inputCodigoModelo ? 
                            <div>
                                <label className="error">{errorValidacion.inputCodigoModelo}</label>
                            </div>
                        :
                            null
                        }
                    </div>


                    <div className="seccionDatosGenerales__nombreModelo">
                        <div className="seccionDatosGenerales__tituloSecundario">Nombre del modelo</div>

                        <input 
                            className="seccionDatosGenerales__inputSelect seccionDatosGenerales__inputNombreModelo"
                            disabled={!puedeModificar}
                            id="inputNombreModelo"
                            name="inputNombreModelo"
                            onChange={(event) => puedeModificar ? this.validarInput(event, "inputNombreModelo") : null}
                            placeholder={esEdicion ? "" : "Ingrese nombre..."}
                            type="text"
                            value={inputNombreModelo}
                        />

                        {errorValidacion.inputNombreModelo ? 
                            <div>
                                <label className="error">{errorValidacion.inputNombreModelo}</label>
                            </div>
                        :
                            null
                        }
                    </div>
                </div>

                <div className="seccionDatosGenerales__contenedor">
                    <div onClick={null}>
                        <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                            <input id={"checkModeloHabilitado"} type="checkbox" checked={checkModeloHabilitado} onChange={() => claseCheckInhabilitado ? null : this.cambiarCheck("checkModeloHabilitado", !checkModeloHabilitado)} />
                            <label className={"label-primary Tarjetas-checkboxLabel" + (checkModeloHabilitado ? claseCheckInhabilitado ? " Tarjetas-checkboxLabelDeshabilitado--checked" : " Tarjetas-checkboxLabel--checked" : "") + claseCheckInhabilitado} htmlFor={"checkModeloHabilitado"}></label>
                        </div>
                        <label className={"label-primary seccionDatosGenerales__label seccionDatosGenerales__checkboxLabelHabilitado" + (claseCheckInhabilitado ? " seccionDatosGenerales__checkboxHabilitado--deshabilitado" : "")}>Habilitado</label>
                        {!checkModeloHabilitado ? <span className={"seccionDatosGenerales__fechaInhabilitado" + (claseCheckInhabilitado ? " seccionDatosGenerales__fechaInhabilitado--deshabilitado" : "")}>{"(Inhabilitado: " + fechaActual + ")"}</span> : null}
                    </div>
                </div>


                <div className="seccionDatosGenerales__contenedor seccionDatosGenerales__marca">
                    <div className="seccionDatosGenerales__tituloSecundario">Marca</div>

                    {arrayRbMarcas}
                </div>

                <div className="seccionDatosGenerales__contenedor">
                    <div className="seccionDatosGenerales__tituloSecundario">Moneda de selección</div>

                    {arrayRbMonedas}
                </div>

                <div className="seccionDatosGenerales__contenedor seccionDatosGenerales__contenedorSucursal">
                    <div className="seccionDatosGenerales__tituloSecundario">Sucursal</div>

                    <div className="seccionDatosGenerales__contenedorSelectSucursal">
                        <select 
                            className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect ABMModelos__seccionDatosGenerales__sucursalSelect"
                            disabled={!puedeModificar}
                            name="comboSucursal"
                            onChange={(event) => {
                                const indice = event.target.selectedIndex;
                                const opcion = event.target.options[indice].value;
                                this.cambiarOpcionCombo("comboSucursal", opcion)
                            }}
                            value={comboSucursal}>
                            {arrayOpcionesSucursal}
                        </select>
                    </div>

                    {/* Si la opción seleccionada es "Todas", muestro el check de Apertura por Sucursal */}
                    {comboSucursal == 0 ?
                        <div className="seccionDatosGenerales__contenedorCheckAperturaPorSucursal">
                            <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                                <input id={"checkAperturaPorSucursal"} type="checkbox" checked={checkAperturaPorSucursal} onChange={() => puedeModificar ? this.cambiarCheck("checkAperturaPorSucursal", !checkAperturaPorSucursal) : null} />
                                <label className={"label-primary Tarjetas-checkboxLabel" + (checkAperturaPorSucursal ? puedeModificar ? " Tarjetas-checkboxLabel--checked" : " Tarjetas-checkboxLabelDeshabilitado--checked" : "") + checkDeshabilitado} htmlFor={"checkAperturaPorSucursal"}></label>
                            </div>
                            <label className={"label-primary seccionDatosGenerales__label seccionDatosGenerales__labelMasAncho" + (puedeModificar ? "" : " seccionDatosGenerales__checkboxHabilitado--deshabilitado")}>Apertura por Sucursal</label>
                        </div>
                    :
                        null
                    }
                </div>

                {/* Si la opción seleccionada es "Todas" y el checkbox de "Apertura por Sucursal" no está tildado, oculto las opciones de "Tipo de sucursal" */}
                    <div className="seccionDatosGenerales__contenedor">
                        <div className="seccionDatosGenerales__tituloSecundario">Tipo de sucursal</div>

                        <div>
                            <GrupoRadioButton 
                                activo={radioButtonsABMModelos.rbTipoSucursal == 1}
                                classLabel={""}
                                estaHabilitado={puedeModificar}
                                label={"Movimiento"}
                                nombre={"rbTipoSucursal"}
                                onClick={puedeModificar ? seleccionarRadioButtonABMModelos : null}
                                valor={1}
                            />
                        </div>

                        <div className="seccionDatosGenerales__tipoSucursalMarginRadioButton">
                            <GrupoRadioButton 
                                activo={radioButtonsABMModelos.rbTipoSucursal == 2}
                                classLabel={""}
                                estaHabilitado={puedeModificar}
                                label={"Radicación de la cuenta"}
                                nombre={"rbTipoSucursal"}
                                onClick={puedeModificar ? seleccionarRadioButtonABMModelos : null}
                                valor={2}
                            />
                        </div>
                    </div>

                <div className="seccionDatosGenerales__contenedor">
                    <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                        <input id={"checkAperturaPorSocio"} type="checkbox" checked={checkAperturaPorSocio} onChange={() => puedeModificar ? this.cambiarCheck("checkAperturaPorSocio", !checkAperturaPorSocio) : null} />
                        <label className={"label-primary Tarjetas-checkboxLabel" + (checkAperturaPorSocio ? puedeModificar ? " Tarjetas-checkboxLabel--checked" : " Tarjetas-checkboxLabelDeshabilitado--checked" : "") + checkDeshabilitado} htmlFor={"checkAperturaPorSocio"}></label>
                    </div>
                    <label className={"label-primary seccionDatosGenerales__label seccionDatosGenerales__labelMasAncho" + (puedeModificar ? "" : " seccionDatosGenerales__checkboxHabilitado--deshabilitado")}>Apertura por Socio</label>
                </div>

                <div className="seccionDatosGenerales__contenedor">
                    <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                        <input id={"checkConfirmacionAutomatica"} type="checkbox" checked={checkConfirmacionAutomatica} onChange={() => puedeModificar ? this.cambiarCheck("checkConfirmacionAutomatica", !checkConfirmacionAutomatica) : null} />
                        <label className={"label-primary Tarjetas-checkboxLabel" + (checkConfirmacionAutomatica ? puedeModificar ? " Tarjetas-checkboxLabel--checked" : " Tarjetas-checkboxLabelDeshabilitado--checked" : "") + checkDeshabilitado} htmlFor={"checkConfirmacionAutomatica"}></label>
                    </div>
                    <label className={"label-primary seccionDatosGenerales__label seccionDatosGenerales__labelMasAncho" + (puedeModificar ? "" : " seccionDatosGenerales__checkboxHabilitado--deshabilitado")}>Confirmación automática (asientos balanceados)</label>
                </div>

                <div className="seccionDatosGenerales__contenedor">
                    <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                        <input id={"checkRequiereReverso"} type="checkbox" checked={checkRequiereReverso} onChange={() => puedeModificar ? this.cambiarCheck("checkRequiereReverso", !checkRequiereReverso) : null} />
                        <label className={"label-primary Tarjetas-checkboxLabel" + (checkRequiereReverso ? puedeModificar ? " Tarjetas-checkboxLabel--checked" : " Tarjetas-checkboxLabelDeshabilitado--checked" : "") + checkDeshabilitado } htmlFor={"checkRequiereReverso"}></label>
                    </div>
                    <label className={"label-primary seccionDatosGenerales__label seccionDatosGenerales__labelMasAncho" + (puedeModificar ? "" : " seccionDatosGenerales__checkboxHabilitado--deshabilitado")}>Requiere reverso (En caso de re-contabilización)</label>
                </div>


                <div className="seccionDatosGenerales__contenedor">
                    <div className="seccionDatosGenerales__tituloSecundario">Días de diferimiento</div>

                    <input 
                        className="seccionDatosGenerales__inputSelect seccionDatosGenerales__diasDiferimiento"
                        disabled={!puedeModificar}
                        id="inputDiasDiferimiento"
                        name="inputDiasDiferimiento"
                        onChange={(event) => puedeModificar ? this.validarInput(event, "inputDiasDiferimiento") : null}
                        placeholder={null}
                        type="text"
                        value={inputDiasDiferimiento}
                    />

                    <div>
                        <label className="seccionDatosGenerales__labelDiasDiferimiento">Valores válidos entre 0 y 10</label>
                    </div>

                    {errorValidacion.inputDiasDiferimiento ? 
                        <div>
                            <label className="error">{errorValidacion.inputDiasDiferimiento}</label>
                        </div>
                    :
                        null
                    }
                </div>

                <div className="seccionDatosGenerales__contenedor seccionDatosGenerales__indicadorInterfaz">
                    <div className="seccionDatosGenerales__tituloSecundario">Indicador de interfaz</div>

                    <IndicadorInterfazBuscador
                        buscarIndicadoresInterfaz={buscarIndicadoresInterfaz}
                        mostrarOcultarResultadosIndicadorInterfaz={mostrarOcultarResultadosIndicadorInterfaz}

                        descripcionIndicadorInterfazSeleccionado={descripcionIndicadorInterfazSeleccionado}
                        mostrarResultadosIndicadorInterfaz={mostrarResultadosIndicadorInterfaz}
                        inputIndicadorInterfaz={inputIndicadorInterfaz}
                        indicadorInterfazFiltrados={indicadorInterfazFiltrados}
                        indicadorInterfazSeleccionado={indicadorInterfazSeleccionado}
                        nombreInput={"inputIndicadorInterfaz"}
                        puedeModificar={puedeModificar}
                    />

                    {errorValidacion.inputIndicadorInterfaz ? 
                        <div>
                            <label className="error">{errorValidacion.inputIndicadorInterfaz}</label>
                        </div>
                    :
                        null
                    }
                </div>


                <div className="seccionDatosGenerales__contenedor">
                    <div className="seccionDatosGenerales__tituloSecundario">Tipo de consolidación para rendición</div>

                    <div>
                        <GrupoRadioButton 
                            activo={radioButtonsABMModelos.rbTipoConsolidacion == 1}
                            classLabel={""}
                            estaHabilitado={puedeModificar}
                            label={"Renglón"}
                            nombre={"rbTipoConsolidacion"}
                            onClick={puedeModificar ? seleccionarRadioButtonABMModelos : null}
                            valor={1}
                        />
                    </div>

                    <div className="seccionDatosGenerales__tipoConsolidacionMarginRadioButton">
                        <GrupoRadioButton 
                            activo={radioButtonsABMModelos.rbTipoConsolidacion == 2}
                            classLabel={""}
                            estaHabilitado={puedeModificar}
                            label={"Cuenta contable y tipo de operación (D / H)"}
                            nombre={"rbTipoConsolidacion"}
                            onClick={puedeModificar ? seleccionarRadioButtonABMModelos : null}
                            valor={2}
                        />
                    </div>

                    <div>
                        <GrupoRadioButton 
                            activo={radioButtonsABMModelos.rbTipoConsolidacion == 3}
                            classLabel={""}
                            estaHabilitado={puedeModificar}
                            label={"Cuenta contable"}
                            nombre={"rbTipoConsolidacion"}
                            onClick={puedeModificar ? seleccionarRadioButtonABMModelos : null}
                            valor={3}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default SeccionDatosGenerales;